<template>
  <div class="evaluationSituationDetail">
    <el-card class="box-card">
      <div class="back">
        <div></div>
        <el-button
          type="primary"
          icon="el-icon-arrow-left"
          size="small"
          @click="goBack"
          >返回</el-button
        >
      </div>
      <company-evaluation-header
        :companyInfo="companyInfo"
        v-if="activeName == 'first'"
      ></company-evaluation-header>
      <manager-header
        :managerInfo="managerInfo"
        type="evaluation"
        v-else
      ></manager-header>
      <score-situation
        :subjectType="subjectType"
        :scoreObj="scoreObj"
        @goToBaseDetail="goToBaseDetail"
      ></score-situation>
      <good-and-bad-score
        :goodList="goodList"
        :badList="badList"
        :scoreInfo="scoreInfo"
        @change="handleGoDetails"
        ref="goodBadScore"
      ></good-and-bad-score>
      <div class="update-time">
        更新时间为 {{ new Date() | dateFormat('yyyy年MM月dd日 00:00:00') }}
      </div>
    </el-card>
  </div>
</template>

<script>
import companyEvaluationHeader from './components/companyEvaluationHeader.vue';
import managerHeader from './components/managerHeader.vue';
import scoreSituation from './components/scoreSituation.vue';
import goodAndBadScore from './components/goodAndBadScore.vue';
import filters from '@/filters/index';
import { CreditEvaApplyController } from '@/service/CreditEvaApplyController/CreditEvaApplyController.js';
import { RegularQueryController } from '@/service/newCreditEvaController/regularQueryController.js';
import { QueryVo } from '@/models/creditEvaluation/QueryVo';

export default {
  name: 'evaluationSituationDetail',
  components: {
    companyEvaluationHeader,
    managerHeader,
    scoreSituation,
    goodAndBadScore,
  },
  data() {
    return {
      subjectType: '',
      companyInfo: {},
      managerInfo: {},
      goodList: [],
      badList: [],
      scoreObj: {},
      scoreInfo: {},
      parameter: new QueryVo(),
    };
  },
  created() {
    this.CreditEvaApplyController = new CreditEvaApplyController();
    this.regularQueryController = new RegularQueryController();
    this.orgCode = this.$route.query.orgCode || '';
    this.mob = this.$route.query.mob || '';
    this.managerName = this.$route.query.managerName
      ? decodeURIComponent(this.$route.query.managerName)
      : '';
    this.orgName = this.$route.query.orgName
      ? decodeURIComponent(this.$route.query.orgName)
      : '';
    this.rankId = this.$route.query.rankId || '';
    this.activeName = this.$route.query.activeName || '';
    this.subjectType = this.$route.query.subjectType || '';
    this.getCreditEvaRanking();
  },
  mounted() {
    if (this.activeName == 'first') {
      this.getCreditEvaInformationVO(2);
      this.getInformationManagementVoList(1, 1);
      this.getInformationManagementVoList(1, 2);
      this.getCreditEvaBasicInfoVOByRole(1);
    } else {
      this.getCreditEvaInformationVO(1);
      this.getInformationManagementVoList(2, 1);
      this.getInformationManagementVoList(2, 2);
      this.getCreditEvaBasicInfoVOByRole(2);
    }
  },
  filters: {
    dateFormat: filters.formatDate,
  },
  methods: {
    // 获取物业企业信息 mob:String, orgCode:String, type:String
    // type 1：项目负责人 2：物业企业
    getCreditEvaInformationVO(type) {
      this.regularQueryController
        .getCreditEvaInformationVO_builtBureauWebsite_v1(
          this.mob,
          this.orgCode,
          type,
          ''
        )
        .then((res) => {
          if (res) {
            if (type == 1) {
              this.managerInfo = res;
            } else {
              this.companyInfo = res;
            }
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 分数信息  keyId:String, dateTime:Date, bodyType:int, type:int
    getCreditEvaRanking() {
      let timeNow = filters.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
      this.regularQueryController
        .getCreditEvaRanking_builtBureauWebsite_v1(
          this.rankId,
          timeNow,
          this.activeName == 'first' ? 1 : 2, // activeName == 'first'代表是企业，2为项目负责人
          '',
          this.orgCode ? this.orgCode : '',
          ''
        )
        .then((res) => {
          if (res) {
            this.scoreInfo = res;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 获取物业企业或项目经理查询信用基础信息 companyCode:String, mob:String, managerName:String, creditBodyType:int
    // creditBodyType  1：物业企业 2:项目经理
    getCreditEvaBasicInfoVOByRole(type) {
      this.regularQueryController
        .getCreditEvaBasicInfoVOByRole_builtBureauWebsite_v1(
          this.orgCode,
          this.mob,
          this.managerName,
          type,
          ''
        )
        .then((res) => {
          if (res) {
            this.scoreObj = res;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // parameter:QueryVo, startIndex:int, maxSize:int, resultTotalCount:boolean, option:int
    // 获取良好列表
    getInformationManagementVoList(suitObj, type) {
      let gbRef = this.$refs.goodBadScore;
      type == 1 ? (gbRef.goodLoading = true) : (gbRef.badLoading = true);
      this.parameter.SuitObj = suitObj;
      this.parameter.OrgCode = this.orgCode;
      this.parameter.MangerName = this.mangerName;
      this.parameter.MangerTel = this.mob;
      this.parameter.Status = '正常';
      // let year = new Date().getFullYear();
      // this.parameter.CreateDateStart = new Date(year + '-01-01 00:00:00');
      // this.parameter.CreateDateEnd = new Date(year + '-12-31 23:59:59');
      this.CreditEvaApplyController.getInformationManagementVoList_builtBureauWebsite(
        JSON.stringify(this.parameter),
        0,
        999,
        true,
        type
      )
        .then((res) => {
          if (res && res._Items) {
            if (type == 1) {
              this.goodList = res._Items;
              gbRef.goodLoading = false;
            } else {
              this.badList = res._Items;
              gbRef.badLoading = false;
            }
          }
        })
        .catch((err) => {
          gbRef.goodLoading = false;
          gbRef.badLoading = false;
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    // 查看详情
    handleGoDetails(row, type) {
      if (type == 'good') {
        if (this.activeName == 'first') {
          this.$router.push({
            path: '/officialGoodInfoDetail',
            query: {
              orgCode: row.OrgCode,
              docCode: row.DocCode,
              applyContent: encodeURIComponent(row.ApplyContent),
              activeName: this.activeName,
            },
          });
        } else {
          this.$router.push({
            path: '/officialGoodInfoDetail',
            query: {
              mob: row.DocCode,
              docCode: row.DocCode,
              applyContent: encodeURIComponent(row.ApplyContent),
              activeName: this.activeName,
            },
          });
        }
      } else {
        if (this.activeName == 'first') {
          this.$router.push({
            path: '/officialBadInfoDetail',
            query: {
              orgCode: row.OrgCode,
              docCode: row.DocCode,
              applyContent: encodeURIComponent(row.ApplyContent),
              activeName: this.activeName,
            },
          });
        } else {
          this.$router.push({
            path: '/officialBadInfoDetail',
            query: {
              mob: row.DocCode,
              docCode: row.DocCode,
              applyContent: encodeURIComponent(row.ApplyContent),
              activeName: this.activeName,
            },
          });
        }
      }
    },
    goToBaseDetail() {
      if (this.activeName == 'first') {
        this.$router.push({
          path: '/companyBaseDetail',
          query: {
            rankId: this.rankId,
            orgCode: this.orgCode,
            orgName: encodeURIComponent(this.orgName),
            activeName: this.activeName,
          },
        });
      } else {
        this.$router.push({
          path: '/officialManagerBaseInfoDetail',
          query: {
            mangerName: encodeURIComponent(this.managerName),
            rankId: this.rankId,
            mob: this.mob,
            orgCode: this.orgCode,
            activeName: this.activeName,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.evaluationSituationDetail {
  width: 100%;
  height: 800px;
  .back {
    display: flex;
    justify-content: space-between;
  }
  .update-time {
    padding-bottom: 8px;
  }
}
</style>
